import { render, staticRenderFns } from "./indexMobile.vue?vue&type=template&id=2948519b&scoped=true"
import script from "./indexMobile.vue?vue&type=script&lang=js"
export * from "./indexMobile.vue?vue&type=script&lang=js"
import style0 from "./indexMobile.vue?vue&type=style&index=0&id=2948519b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948519b",
  null
  
)

export default component.exports